export default __webpack_public_path__ + "static/media/psicologo-system.9886de70.png";